import { RetryLink } from '@apollo/client/link/retry'

import { envVariables } from '../../lib/env'
import { logger } from '../logger'
import { LOGGER_EVENTS } from '../logger_events'

// https://www.apollographql.com/docs/react/api/link/apollo-link-retry/
export const retryLink = new RetryLink({
  attempts: {
    max: envVariables.NODE_ENV === 'development' ? 3 : 3, // 開発環境でもホットリロードが走った際に通信エラー表示がでるのを避けるため、リトライする
    retryIf: (error, operation) => {
      // mutationはリトライしない。queryのみretryする。
      // queryは必ずfetchにする命名規則になっているはず
      return operation.operationName.startsWith(`fetch`)
    },
  },
  delay: (count, operation, error) => {
    if (error instanceof Error) {
      const message = `${error.name}: ${error.message}, retry: ${count}, operation: ${operation.operationName}`
      void logger?.error(LOGGER_EVENTS.APOLLO_CLIENT, message)
      // eslint-disable-next-line no-console
      console.warn(message)
    }
    return 2000 * 1.5 ** count
  },
})
